import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Home } from '../pages/Landing/Home'
import { NotFound } from '../components/NotFound'
import { Header } from '../components/Layout/Header'
import { Footer } from '../components/Layout/Footer'
import { About } from '../pages/About/About'


export const Routers = () => {

    return (
        <div>
            <Header />
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/about' element={<About />} />
                <Route path='*' element={<NotFound />} /> 
            </Routes>
            <Footer />
        </div>
    )
}